// removed by extract-text-webpack-plugin
module.exports = {"badge":"badge"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/Badge/style.scss
// module id = 1277
// module chunks = 0